module.exports = __webpack_public_path__ + "static/staff-3-8bb54cc165f567fe55e9b91bd188ca6b.png";